<template>
  <div class="d-flex flex-column justify-content-center align-items-center" style="height: 100vh;">
    <h1>Hello</h1>
    <span>👋</span>
    <button @click="logout" class="btn btn-outline-light mt-2">Logout</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
    logout() {
      localStorage.removeItem('rtcrobotsecretid');
      localStorage.removeItem('rtcrobotsecretkey');
      localStorage.removeItem('rtcrobotroomid');
      localStorage.removeItem('rtcrobotrole');
      this.$USER.secretId = null;
      this.$USER.secretKey = null;
      this.$USER.roomId = null;
      this.$USER.role = null;
    },
  }
};
</script>

<style scoped>
</style>
